import React from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Button,
  Checkbox,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import TextEditor from "@icarius-common/textEditor";
import { DeleteIcon } from "@icarius-icons/index";

const gridStyle = { padding: 10 };

const QuestionFormDialog = (props) => {

  const {
    open,
    readOnly,
    data,
    questionTypes,
    submitCallback,
    handleClose,
  } = props;

  const dispatch = useDispatch();

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    isCreate,
    formData,
    setAnswerOption,
    deleteAnswerOption,
    setFormValue,
    submit,
  } = useHandleForm(data, submitCallback, openValidationError);

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {isCreate ? getLocalizedString("createQuestion") : getLocalizedString("updateQuestion")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <InputLabel shrink required>
                {getLocalizedString("question")}
              </InputLabel>
              <div style={{ width: "100%", marginTop: 5 }}>
                <TextEditor
                  disabled={readOnly}
                  initialValue={formData.text}
                  placeholder={getLocalizedString("text")}
                  handleChange={(value) => setFormValue(value, "text")}
                  allowImages
                />
              </div>
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-type`}>{getLocalizedString("questionType")}</InputLabel>
                <Select
                  disabled={readOnly}
                  value={formData.type}
                  labelId={`label-type`}
                  id={`select-type`}
                  onChange={(e) => setFormValue(e.target.value, "type")}
                  margin={"none"}
                >
                  {
                    questionTypes.map((item) => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            {
              formData.type !== "D" &&
              <Grid container item alignItems="center" xs={12} style={gridStyle}>
                <Typography className="whiteText" style={{ paddingBottom: 10 }}>
                  {getLocalizedString("answers")}
                </Typography>
                {
                  formData.answers.map((answer, answerIndex) => {
                    return (
                      <Grid key={answerIndex} container item alignItems="center" xs={12} style={{ paddingBottom: 15 }}>
                        <Checkbox
                          disabled={readOnly}
                          checked={answer.isCorrect}
                          onChange={() => setAnswerOption(answerIndex, { ...answer, isCorrect: !answer.isCorrect })}
                        />
                        <TextField
                          disabled={readOnly}
                          style={{ flex: 1, marginRight: 10 }}
                          required
                          fullWidth
                          margin={"none"}
                          label={getLocalizedString("answer")}
                          value={answer.text}
                          onChange={(e) => setAnswerOption(answerIndex, { ...answer, text: e.target.value })}
                        />
                        {
                          !readOnly &&
                          <IconButton size="small" onClick={() => deleteAnswerOption(answerIndex)}>
                            <DeleteIcon />
                          </IconButton>
                        }
                      </Grid>
                    )
                  })
                }
                {
                  !readOnly &&
                  <Button
                    style={{ margin: "0 auto" }}
                    className="whiteText"
                    variant="contained"
                    onClick={() => setAnswerOption(formData.answers.length)}
                  >
                    {getLocalizedString("addAnswer")}
                  </Button>
                }
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          {
            !readOnly &&
            <>
              <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
              <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
            </>
          }
          {readOnly && <ButtonDialogAction onClick={handleClose} isAccept text={getLocalizedString("close")} />}
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default QuestionFormDialog;
